<template>
    <b-modal id="tagManager" title="Tags" hide-footer>
        <div>
            <b-form @submit.stop.prevent @submit="onSubmit" class="mb-3">
                <b-form-group  label="Nova Tag">
                        <div class="d-flex justify-content-between gap-2">

                            <b-form-input
                                required
                                v-model="form.name">

                            </b-form-input>
                            <b-button type="submit"   variant="primary" :disable="loading">
                                Salvar
                            </b-button>
                        </div>
                </b-form-group>
            </b-form>
        </div>

        <b-overlay :show="loading">
            <div v-if="tags.length > 0">
                <div v-for="tag, index in tags" :key="tag.id" class="my-1">
                    <div class="d-flex justify-content-between gap-2">
                        <div class="d-flex w-100 align-items-center pl-2 bg-light text-black-50" v-if="!tag.onEdit">{{ tag.newName }}</div>
                        <b-form-input type="text" v-else v-model="tag.newName"></b-form-input>

                        <div class="d-flex gap-2">
                            <div class="p-1 btn btn-outline-info px-1" role="button" v-if="!tag.onEdit" @click="onClickEdit(index)">
                                <svg height="20px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                </svg>
                            </div>
                            <div class="p-1 btn btn-outline-success px-1 " role="button" v-else @click="onClickUpdate(index)">
                                <svg height="20px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                </svg>
                            </div>
                            <div class="p-1 btn btn-outline-danger px-1" role="button" v-b-modal.deleteConfirm @click="onClickDelete(tag)">
                                <svg height="20px"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                  </svg>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
        <b-modal hide-footer id="deleteConfirm" title="Confirmação" v-if="tag">
            deseja remover a tag <b>{{ tag.name }}</b>? todos os temas que possuem essa tag serão afetados

           <div class="w-auto mt-3 d-flex gap-2 justify-content-end">
            <button class="btn btn-light" @click="$bvModal.hide('deleteConfirm')" >Cancelar</button>
            <button class="btn btn-danger" @click="deleteTag">Remover</button>
           </div>
        </b-modal>
    </b-modal>


</template>

<script>
export default {
    data(){
        return {
            loading: false,
            tags: [],
            tag: null,
            form: {
                name: ''
            },
            endpoint: '/teacher/tags'
        }
    },
    created(){
        this.load()

        this.$root.$on('tagManager', () => {
            this.$bvModal.show('tagManager')
        });
    },
    methods: {
        load(){
            this.loading = true
            axios.get(this.endpoint)
                .then((result) => {
                    const response = result.data

                    this.tags = response;

                    let tmpArray = []
                    this.tags.forEach((tag)=>{
                    tmpArray.push({...tag, onEdit: false, newName: tag.name})
                    })

                    this.tags = tmpArray

                }).catch((err) => {

                })
                .finally(()=>{
                    this.loading = false
                })
        },
        onSubmit(){
            axios.post(this.endpoint, {
                name: this.form.name,
            })
            .then((result) => {
                const response = result.data;

                this.load()
                this.form.name = ''
                this.$toast.success('Tag Criada com sucesso');
            }).catch((err) => {

            });
        },

        onClickUpdate(index){
            const tag = this.tags[index]
            if(tag.newName === tag.name){
                this.tags[index].onEdit = false
                return
            }

            this.loading = true
            axios.put(`${this.endpoint}/${tag.id}`,{
                name: tag.newName
            })
            .then((result)=>{
                const response = result.data.data

                this.load()
            })
            .finally(()=>{
                this.loading = false
            })
        },

        onClickDelete(tag){
            this.tag = tag;

        },

        deleteTag(){
            this.loading = true
            axios.delete(`${this.endpoint}/${this.tag.id}`)
            .then((result)=>{
                const response = result.data.data

                this.load()
            })
            .finally(()=>{
                this.loading = false
                this.$bvModal.hide('deleteConfirm')
            })

        },

        onClickEdit(index){
            this.tags[index].onEdit = true

        }
    }
}

</script>

<style>

</style>
